import { HttpParams } from "@angular/common/http";
import { Component, inject, OnInit } from "@angular/core";
import { TreeNode } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { PromptTreeService } from "src/app/common/services/prompt-tree.service";
import { PredefinedPrompt } from "src/app/modules/prompts/models/prompt-template.model";
import { PromptsService } from "src/app/modules/prompts/services/prompts.service";

@Component({
  templateUrl: "./move-dialog.component.html",
  styleUrl: "./move-dialog.component.scss",
})
export class MoveDialogComponent implements OnInit {
  protected selectedNode?: TreeNode<PredefinedPrompt>;
  protected savedNodes: TreeNode<PredefinedPrompt>[] = [];

  protected readonly ref = inject(DynamicDialogRef);
  private readonly promptsService = inject(PromptsService);
  private readonly promptTreeService = inject(PromptTreeService);
  private readonly dialogConfig: DynamicDialogConfig<{
    node: TreeNode<PredefinedPrompt>;
    nodeType: "group" | "prompt";
  }> = inject(DynamicDialogConfig);

  protected readonly PromptNode!: TreeNode<PredefinedPrompt>;

  ngOnInit(): void {
    void this.setSavedNodes();
  }

  private async setSavedNodes(): Promise<void> {
    const excludedLabels = this.getExcludedLabels();
    const promptModels = await this.promptsService.listTemplates(new HttpParams().appendAll({ category: "" }));
    const promptItems = this.promptTreeService.buildHierarchy({
      models: promptModels,
      maxDepth: 3,
      onlyCategories: true,
    });
    this.savedNodes.push(...promptItems);
    this.savedNodes = this.updateRecursive(this.savedNodes, excludedLabels);
    console.log("savedNodes", this.savedNodes);
  }

  private getExcludedLabels(): string[] {
    let node = this.dialogConfig.data?.node;
    let isMyPrompts = false;
    while (node) {
      if (node.data!.label === "MES_PROMPTS") {
        isMyPrompts = true;
        break;
      }
      node = node.parent;
    }
    return isMyPrompts ? ["SUMMARY"] : ["SUMMARY", "MES_PROMPTS"];
  }

  private updateRecursive(nodes: TreeNode<PredefinedPrompt>[], excludedLabels: string[]): TreeNode<PredefinedPrompt>[] {
    nodes = nodes.filter((node) => node.data!.id !== this.dialogConfig.data!.node.data!.id);
    nodes = nodes.filter((node) => !excludedLabels.includes(node.data!.label ?? ""));
    // Recursively sort the children of a node
    nodes = nodes.toSorted((a, b) => (a.label ?? "").localeCompare(b.label ?? ""));
    for (const node of nodes) {
      node.children = this.updateRecursive(node.children ?? [], excludedLabels);
    }
    return nodes;
  }

  async move(): Promise<void> {
    const parentId = this.selectedNode?.data?.id;
    const childId = this.dialogConfig.data?.node?.data?.id;
    if (!parentId || !childId) {
      throw new Error(
        `Parent or child ID is undefined,
         selectedNode: ${JSON.stringify(this.selectedNode)},
         dialogConfig.data: ${JSON.stringify(this.dialogConfig.data)}
        `.replace(/\s+/g, " "),
      );
    }
    if (this.dialogConfig.data!.nodeType === "group") {
      await this.promptsService.moveGroup(childId, parentId);
    } else if (this.dialogConfig.data!.nodeType === "prompt") {
      await this.promptsService.movePrompt(childId, parentId);
    }
    this.ref.close(true);
  }
}
